// Libraries
// @ts-expect-error this library is not typed
import planer from 'planer';

const getEmailMimeType = (emailText: string) => {
  // No angle brackets, it's plain text.
  if (!/[<>]/.test(emailText) || !/<\/[^>]+>/.test(emailText)) {
    return 'text/plain';
  }

  // Parse into a DOM; if we get any element nodes, call it HTML.
  const doc = new DOMParser().parseFromString(emailText, 'text/html');
  console.log('doc', doc);
  const hasRealElements = Array.from(doc.body.childNodes).some(
    (n) => n.nodeType === Node.ELEMENT_NODE,
  );

  return hasRealElements ? 'text/html' : 'text/plain';
};

const stripEmailReplies = (emailText: string) => {
  const mimeType = getEmailMimeType(emailText);
  if (mimeType === 'text/plain') {
    return planer.extractFrom(emailText, 'text/plain');
  }
  return planer.extractFrom(emailText, 'text/html', window.document);
};

export default stripEmailReplies;
